export default __webpack_public_path__ + "static/media/i_wdt_c_0_1.f1dffc35.mp3";